import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=837f777a&scoped=true&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=837f777a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f777a",
  null
  
)

export default component.exports